import { FormEvent } from "react";
import styles from "./NotesFooter.module.css";
import StyledButton from "../common/buttons/StyledButton";
import checkboxFilledIcon from "../../assets/checkbox-dark-filled.svg";
import checkboxUnfilledIcon from "../../assets/checkbox-dark-unfilled.svg";
import ValidationMessage from "../common/ValidationMessage/ValidationMessage";
import { ChannelMapToFull } from "../../lib/channelUtil";
import { Channel } from "../../lib/api/models";

const strings = {
  addNote: "Add Note",
  critical: "Critical",
  checked: "Checked",
  unchecked: "Unchecked",
  channel: (c: string) => `Channel: ${c}`,
};

type Props = {
  note: string;
  setNote: React.Dispatch<React.SetStateAction<string>>;
  isCritical: boolean;
  setIsCritical: React.Dispatch<React.SetStateAction<boolean>>;
  validationMessages: string[];
  setValidationMessages: React.Dispatch<React.SetStateAction<string[]>>;
  onSubmit: () => void;
  isSubmitting: boolean;
  channel: Channel;
};

export default function NotesFooter(props: Props) {
  function onSubmit(e: FormEvent) {
    e.preventDefault();
    props.onSubmit();
  }

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={onSubmit}>
        <textarea
          className={styles.textarea}
          value={props.note}
          onChange={(e) => props.setNote(e.target.value)}
          rows={3}
          maxLength={4000}
        />
        <div>
          <div className={styles.buttonsContainer}>
            <div className={styles.checkboxContainer}>
              <label className={styles.checkboxInnerContainer}>
                <input
                  className={styles.checkboxInput}
                  type="checkbox"
                  checked={props.isCritical}
                  onChange={(e) => props.setIsCritical(e.target.checked)}
                />
                <img
                  src={
                    props.isCritical ? checkboxFilledIcon : checkboxUnfilledIcon
                  }
                  alt={props.isCritical ? strings.checked : strings.unchecked}
                />
              </label>
              <div className={styles.checkboxLabel}>{strings.critical}</div>
            </div>
            <StyledButton
              className={styles.addNoteButton}
              disabled={!props.note.trim()}
              isLoading={props.isSubmitting}
              type="submit"
            >
              {strings.addNote}
            </StyledButton>
          </div>
          <div className={styles.channelIndicator}>
            {strings.channel(ChannelMapToFull[props.channel])}
          </div>
        </div>
      </form>
      <ValidationMessage validationMessages={props.validationMessages} />
    </div>
  );
}
